import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/mijn-mkg/(with_tracking)/support/systeembeheer/sb.module.scss");
